import { WritingTab } from './WritingTab'
import { withWritingTab } from './withWritingTab'

const ConnectedWritingTab = withWritingTab(WritingTab)

export { ConnectedWritingTab as WritingTab }
